export default "__VITE_ASSET__B1IBpAP1__"